<template>
    <div>
        <div id="panel-4" class="panel">
            <div class="panel-hdr">
                <h2>
                    {{ __t('LIST') }}
                    <span class="fw-300">
                        <i>{{ __t('ACTIONS') }}</i>
                    </span>
                </h2>

                <div class="panel-toolbar">
                    <button
                        class="btn btn-panel waves-effect waves-themed"
                        data-action="panel-fullscreen"
                        data-toggle="tooltip"
                        data-offset="0,10"
                        data-original-title="Fullscreen"
                    ></button>
                </div>
            </div>

            <div class="panel-container show">
                <div class="panel-content">
                    <div class="row">
                        <div class="col-md-3">
                            <pwa_action_groups
                                v-model="filter.groups"
                                @change="handleGroupsChange"
                            />
                        </div>

                        <div class="col-md-9">
                            <b-skeleton-table
                                v-if="is_load"
                                :rows="cur_records"
                                :columns="2"
                                :hide-header="true"
                                :table-props="{
                            bordered: false,
                            striped: true
                        }"
                            />
                            <div v-if="!is_load" class="inbox_vue_list">
                                <div
                                    v-if="rows.length > 0"
                                    class="inb_pagi pt-4"
                                >
                                    <pagination_list
                                        key="up"
                                        :total="pagination.total"
                                        :limit="pagination.limit"
                                        :current="pagination.pagesCurrent"
                                        @page-change="handlePageChange"
                                    />
                                </div>

                                <b-table
                                    v-if="rows.length > 0"
                                    striped
                                    class="table-responsive-xl resolution_table"
                                    :tbody-tr-class="rowClass"
                                    :items="rows"
                                    :fields="fields"
                                >
                                    <!-- Заголовок статуса -->
                                    <template v-slot:head(id)>
                                        <div
                                            class="status_info"
                                            style="max-width: 50px"
                                        >
                                            {{ __t('STATUS') }}
                                        </div>
                                    </template>

                                    <!-- Сортировка по ID/uniq_id -->
                                    <template v-slot:head(uniq_id)>
                                        <grid_list
                                            list_ordering="id"
                                            field_name="ID"
                                            :current_ordering="list.ordering"
                                            :current_direction="list.direction"
                                            @update-order="handleOrdering"
                                        />
                                    </template>

                                    <!-- Сортировка по названию -->
                                    <template v-slot:head(title)>
                                        <grid_list
                                            list_ordering="title"
                                            :field_name="__t('TITLE')"
                                            :current_ordering="list.ordering"
                                            :current_direction="list.direction"
                                            @update-order="handleOrdering"
                                        />
                                    </template>

                                    <!-- Статус публикации -->
                                    <template v-slot:cell(id)="data">
                                        <div class="custom-control custom-checkbox">
                                            <input
                                                :id="data.item.id + '_cust_id'"
                                                v-model="data.item.published"
                                                :name="'cid[]'"
                                                type="checkbox"
                                                class="custom-control-input"
                                                @change="save_action_publish(data.item)"
                                            />

                                            <label
                                                class="custom-control-label cursor-pointer bolder"
                                                :for="data.item.id + '_cust_id'"
                                            ></label>
                                        </div>
                                    </template>

                                    <!-- Основная информация -->
                                    <template v-slot:cell(uniq_id)="data">
                                        <div>
                                            <div class="d-flex flex-start w-100 fs-xl mb-2">
                                                <div
                                                    class="icon-stack fs-xxl mr-2 cursor-pointer"
                                                    @click="open_item(data.item)"
                                                >
                                                    <i class="base base-15 icon-stack-3x opacity-100 color-primary-900"></i>
                                                    <i class="fal fa-indent icon-stack-1x opacity-100 color-white"></i>
                                                </div>

                                                {{ data.item.title }}

                                                <span class="small text-info pl-2">
                                            <i
                                                v-if="data.item.skeep_sync"
                                                class="fal fa-lock"
                                                :title="__t('MOD_SKIP_SYNC')"
                                            ></i>

                                            <i
                                                v-if="data.item.hidden"
                                                class="fal fa-user-ninja"
                                                :title="__t('MOD_HIDDEN')"
                                            ></i>
                                        </span>
                                            </div>

                                            <div class="d-flex flex-start w-100">
                                                <div
                                                    v-if="data.item.action_group"
                                                    class="small badge border border-info"
                                                >
                                                    {{ __t(data.item.action_group.title) }}
                                                </div>

                                                <div
                                                    v-if="data.item.promocode"
                                                    class="small badge border border-success ml-3"
                                                >
                                                    {{ data.item.promocode }}
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Название для корзины -->
                                    <template v-slot:cell(title)="data">
                                        <div class="prod_name fs-xl color-success-600">
                                    <span
                                        v-html="nice_search(data.item.cart_title)"
                                    ></span>
                                        </div>

                                        <div>
                                            <div class="small badge border border-warning">
                                                ID: {{ data.item.id }}
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Доставка / самовывоз -->
                                    <template v-slot:cell(in_delivery)="data">
                                        <div class="params_info">
                                            <div v-if="data.item.in_delivery">
                                                <div class="small badge badge-info">
                                                    {{ __t('IN_DELIVERY') }}
                                                </div>
                                            </div>

                                            <div v-if="data.item.in_pickup">
                                                <div class="small badge badge-warning">
                                                    {{ __t('IN_PICKUP') }}
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Минимальная сумма -->
                                    <template v-slot:cell(min_sum)="data">
                                        <div class="prod_price bold color-primary-900 mt-1">
                                            {{
                                                new Intl.NumberFormat('ru-RU').format(
                                                    parseFloat(data.item.min_sum || 0)
                                                )
                                            }}
                                        </div>
                                    </template>
                                </b-table>

                                <div
                                    v-if="rows.length > 0"
                                    class="inb_pagi pt-4"
                                >
                                    <pagination_list
                                        key="down"
                                        :total="pagination.total"
                                        :limit="pagination.limit"
                                        :current="pagination.pagesCurrent"
                                        @page-change="handlePageChange"
                                    />
                                </div>

                                <div
                                    v-if="rows.length === 0"
                                    class="text-center py-5 text-muted"
                                >
                                    {{ __t('NO_ITEMS') }}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="filter_block mb-3">
                        <!-- Фильтры акций подключаются отдельно -->
                    </div>




                </div>
            </div>

            <action_modal />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import Grid_list from "../../../sys/list/grid_list.vue";
import Pagination_list from "../../../sys/list/pagination_list.vue";
import Action_modal from "../modal/action_modal.vue";
import Pwa_action_groups from "./pwa_action_groups.vue";
export default {
    name: "pwa_action_list",

    components: {
        Action_modal,
        Grid_list,
        Pagination_list,
        Pwa_action_groups,
    },

    data() {
        return {
            rows: [],
            is_load: true,
            cur_records: 35,

            list: {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 30,
            },

            pagination: {
                total: 0,
                limit: 30,
                pagesCurrent: 1,
            },

            filter: {
                search: "",
                groups: [],
                provider_id: "",
                city_id: "",
                rest_group: "",
            },

            fields: [
                {
                    key: "id",
                    label: "",
                    class: "text-center",
                },
                {
                    key: "uniq_id",
                    label: '<i class="fal fa-cog width-2"></i>',
                    class: "",
                },
                {
                    key: "title",
                    label: "title",
                    class: "",
                },
                {
                    key: "in_delivery",
                    label: "Params",
                    class: "",
                },
                {
                    key: "min_sum",
                    label: this.__t("MIN_PRICE"),
                    class: "",
                },
            ],
        };
    },

    mounted() {
        this.load_items();
    },

    created() {
        EventBus.$on("search_action_called", this.search_work);
        EventBus.$on("actions_reload_items", this.load_items);
        EventBus.$on("clean_action_filter", this.clean_inbox_filter);
        EventBus.$on("filter_select_change", this.filter_select);
        EventBus.$on("reload_actions", this.load_items);
    },

    beforeDestroy() {
        EventBus.$off("search_action_called", this.search_work);
        EventBus.$off("actions_reload_items", this.load_items);
        EventBus.$off("clean_action_filter", this.clean_inbox_filter);
        EventBus.$off("filter_select_change", this.filter_select);
        EventBus.$off("reload_actions", this.load_items);
    },

    methods: {
        handleOrdering({ ordering, direction }) {
            this.list.ordering = ordering;
            this.list.direction = direction;
            this.list.start = 0;

            this.load_items();
        },
        handleGroupsChange(groups) {
            this.filter.groups = groups;
            this.list.start = 0;
            this.load_items();
        },
        handlePageChange({ page, start }) {
            this.list.start = parseInt(start) || 0;

            this.load_items();
        },

        search_work(searchStr) {
            this.filter.search = searchStr || "";
            this.list.start = 0;

            this.load_items();
        },

        filter_select(res) {
            if (!res || !res.type) {
                return;
            }

            this.$set(this.filter, res.type, res.value);
            this.list.start = 0;

            this.load_items();
        },

        clean_inbox_filter() {
            this.filter = {
                search: "",
                groups: [],
                provider_id: "",
                city_id: "",
                rest_group: "",
            };

            this.list = {
                ordering: "id",
                direction: "DESC",
                start: 0,
                limit: 30,
            };

            this.load_items();
        },

        async save_action_publish(item) {
            const previousValue = !item.published;

            try {
                const { data } = await api.patch(
                    `/internal/v1/catalog/pwa/actions/${parseInt(item.id)}/state`
                );

                if (data.status !== "operation_success") {
                    item.published = previousValue;
                }
            } catch (error) {
                item.published = previousValue;

                const response = error.response;

                EventBus.$emit("show_toast", {
                    err: response?.data?.message || error.message,
                    type: "danger",
                    title: response?.data?.status || "error",
                });
            }
        },

        async load_items() {
            this.rows = [];
            this.is_load = true;

            try {
                const { data } = await api.post(
                    "/internal/v1/catalog/pwa/actions",
                    {
                        filter: this.filter,
                        list: this.list,
                    }
                );

                if (data.status === "operation_success") {
                    this.rows = Array.isArray(data.data)
                        ? data.data
                        : [];

                    if (data.message?.pagination) {
                        this.pagination = {
                            ...this.pagination,
                            ...data.message.pagination,
                        };
                    }
                } else {
                    this.rows = [];
                }
            } catch (error) {
                this.rows = [];

                const response = error.response;

                EventBus.$emit("show_toast", {
                    err: response?.data?.message || error.message,
                    type: "danger",
                    title: response?.data?.status || "error",
                });
            } finally {
                this.is_load = false;
            }
        },

        rowClass(item) {
            if (!item) {
                return;
            }

            return item.class;
        },

        open_item(item) {
            EventBus.$emit(
                "action_edit",
                parseInt(item.id)
            );
        },

        create() {
            EventBus.$emit("action_edit", 0);
        },

        nice_search(value) {
            const str = String(value || "");
            const search = String(this.filter.search || "").trim();

            if (!search) {
                return str;
            }

            const escapedSearch = search.replace(
                /[.*+?^${}()|[\]\\]/g,
                "\\$&"
            );

            return str.replace(
                new RegExp(escapedSearch, "i"),
                match => `<span class="text-danger">${match}</span>`
            );
        },
    },

    computed: {
        ...mapGetters({
            user: "user/getUser",
        }),
    },
};
</script>

<style scoped>
.table thead th:first-child {
    max-width: 20px;
}

.prod_price {
    font-size: 20px;
}
</style>
